/** @jsx isolateComponent */

import * as React from 'react';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

type MarginProps = {
  /**
   * Sets margins on this component.
   */
  margin?: string | number;
  /**
   * Anything you want to render with a margin wrapped around it.
   */
  children: React.ReactNode;
};

const Styles = labelStyles(__filename, {
  root: (props: MarginProps) => ({
    margin: props.margin,
  }),
});

/**
 * Wraps any node with a `div` that is styled with the specified `margin`.
 *
 * For putting margins on things without needing to put the margins directly on
 * the things.
 *
 * Tags: core-ui
 */
const Margin: React.FC<MarginProps> = props => (
  <div css={Styles.root(props)}>{props.children}</div>
);

export default Margin;
